import { Box, Stack, Typography } from '@mui/material';

interface Props {
  icon: React.ReactNode;
  label: string;
  sublabel: string;
  onClick: () => void;
}

export default function MethodTile({ icon, label, sublabel, onClick }: Props) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        flex: 1,
        minWidth: 0,
        cursor: 'pointer',
        border: '1px solid rgba(20, 18, 15, 0.08)',
        borderRadius: '16px',
        backgroundColor: '#FFFFFF',
        padding: '18px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 1.25,
        textAlign: 'left',
        transition:
          'transform 160ms cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 160ms ease, border-color 160ms ease, background-color 160ms ease',
        boxShadow: '0 1px 0 rgba(20, 18, 15, 0.02)',
        '&:hover': {
          transform: 'translateY(-2px)',
          borderColor: 'rgba(255, 48, 8, 0.55)',
          backgroundColor: '#FFFBFA',
          boxShadow:
            '0 12px 24px -12px rgba(255, 48, 8, 0.22), 0 0 0 4px rgba(255, 214, 206, 0.45)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
        '&:focus-visible': {
          outline: 'none',
          borderColor: '#FF3008',
          boxShadow: '0 0 0 4px rgba(255, 48, 8, 0.18)',
        },
      }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '12px',
          backgroundColor: '#FFD6CE',
          color: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}>
        {icon}
      </Box>
      <Stack spacing={0.25} sx={{ minWidth: 0, width: '100%' }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'Montserrat, sans-serif',
            color: 'text.primary',
          }}>
          {label}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.tertiary' }}>
          {sublabel}
        </Typography>
      </Stack>
    </Box>
  );
}
